import {addListener, makeKey, setEnabled} from "OK/CommentWidgetsController";
import {IHash} from "OK/utils/utils";

const formsStorage: IHash<CommentForm[]> = {};

function register(form: CommentForm) {
    const key = form.getKey();
    if (!formsStorage.hasOwnProperty(key)) {
        formsStorage[key] = [];
    }
    formsStorage[key].push(form);
}

function unregister(form: CommentForm) {
    if (!formsStorage.hasOwnProperty(form.getKey())) {
        return;
    }
    const forms = formsStorage[form.getKey()];
    for (let i = forms.length - 1; i >= 0; i--) {
        if (forms[i] === form) {
            forms.splice(i, 1);
        }
    }
}

export class CommentForm {
    private el!: HTMLElement;
    private isAnonym: boolean = false;
    private discussionSubjectId!: string;
    private discussionType!: number;
    private key!: string;

    static setCountInWidgets(key: string, count: number) {
        // ничего не делаем
    }

    static setEnabled(key: string, enabled: boolean) {
        if (!formsStorage.hasOwnProperty(key)) {
            return;
        }
        formsStorage[key].forEach(form => form.setEnabled(enabled));
    }

    activate(el: HTMLElement) {
        this.el = el;
        this.isAnonym = !!el.getAttribute('data-anonym-comments');
        if (this.isAnonym) {
            return;
        }
        this.discussionSubjectId = el.getAttribute('data-discussion-subject-id')!;
        this.discussionType = +el.getAttribute('data-discussion-type')!;
        this.key = makeKey(this.discussionSubjectId, this.discussionType);

        // возможно, приехала свежая инфа по дискуссиям - обновляем
        setEnabled(this.discussionSubjectId, this.discussionType, el.getAttribute('data-comments-denied') !== '1')

        register(this);
    }

    deactivate(el: HTMLElement) {
        if (!this.isAnonym) {
            unregister(this);
        }
    }

    getKey() {
        return this.key;
    }

    setEnabled(enabled: boolean) {
        this.el.classList.toggle('invisible', !enabled);
    }
}

addListener(CommentForm);
